import React from "react";
import { Card, Row, Col } from "antd";
import { DesktopOutlined, AppstoreOutlined } from "@ant-design/icons";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import Footer from "Common/Footer";

function Assets() {
  const navigate = useNavigate();

  const handleHardwareClick = () => {
    navigate("/hardware-assets");
  };

  const handleSoftwareClick = () => {
    navigate("/software-assets");
  };

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <br />
          <Card title="Assets Management" className="card-professional">
            <Row justify="center" gutter={[24, 24]} style={{ marginTop: "20px", padding: "20px" }}>
              
              {/* Hardware Assets Card */}
              <Col xs={24} sm={12} md={8} lg={6}>
                <div onClick={handleHardwareClick} style={{ cursor: 'pointer' }}>
                  <Card className="pro-green-card doc-card-1">
                    <div className="pro-card-content">
                      <div className="card-icon">
                        <DesktopOutlined />
                      </div>
                      <h3>Hardware Assets</h3>
                    </div>
                  </Card>
                </div>
              </Col>

              {/* Software Assets Card */}
              <Col xs={24} sm={12} md={8} lg={6}>
                <div onClick={handleSoftwareClick} style={{ cursor: 'pointer' }}>
                  <Card className="pro-green-card doc-card-2">
                    <div className="pro-card-content">
                      <div className="card-icon">
                        <AppstoreOutlined />
                      </div>
                      <h3>Software Assets</h3>
                    </div>
                  </Card>
                </div>
              </Col>

            </Row>
          </Card>
        </div>
        <Footer />
      </div>
    </DashboardLayout>
  );
}

export default Assets;